import { ThemeOptions } from '@mui/material';

import * as MuiAutocomplete from './MuiAutocomplete';
import * as MuiButton from './MuiButton';
import * as MuiButtonGroup from './MuiButtonGroup';
import * as MuiCheckbox from './MuiCheckbox';
import * as MuiLoadingButton from './MuiLoadingButton';
import * as MuiRadio from './MuiRadio';
import * as MuiSelect from './MuiSelect';
import * as MuiSlider from './MuiSlider';
import * as MuiSwitch from './MuiSwitch';
import * as MuiTextField from './MuiTextField';
import * as MuiToggleButton from './MuiToggleButton';
import * as MuiToggleButtonGroup from './MuiToggleButtonGroup';

export type {} from './MuiAutocomplete';
export type {} from './MuiButton';
export type {} from './MuiButtonGroup';
export type {} from './MuiCheckbox';
export type {} from './MuiLoadingButton';
export type {} from './MuiRadio';
export type {} from './MuiSlider';
export type {} from './MuiSwitch';
export type {} from './MuiTextField';
export type {} from './MuiToggleButton';
export type {} from './MuiToggleButtonGroup';

export const inputs: ThemeOptions['components'] = {
  ...MuiAutocomplete,
  ...MuiButton,
  ...MuiButtonGroup,
  ...MuiLoadingButton,
  ...MuiRadio,
  ...MuiSelect,
  ...MuiSlider,
  ...MuiSwitch,
  ...MuiTextField,
  ...MuiCheckbox,
  ...MuiToggleButton,
  ...MuiToggleButtonGroup
};
